<template>
  <div>
    EventTypes:
    <v-layout>
      <v-flex xs1 :style="{color: getEventColor('ChangeRequested')}">
        <v-switch v-model="proxyValue" label="Requested" value="ChangeRequested"/>
      </v-flex>
      <v-flex xs1 :style="{color: getEventColor('ChangeExecuted')}">
        <v-switch v-model="proxyValue" label="Executed" value="ChangeExecuted"/>
      </v-flex>
      <v-flex xs1 :style="{color: getEventColor('ChangeChecked')}">
        <v-switch v-model="proxyValue" label="Checked" value="ChangeChecked"/>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import {getEventColor} from "./caseServiceLogUtils";

  export default {
    name: 'event-type-select',
    props: {
      value: {
        type: Array
      }
    },
    data() {
      return {}
    },
    computed: {
      proxyValue: {
        get() {
          return this.value;
        },
        set(newValue) {
          this.$emit('input', newValue)
        }
      }
    },
    methods: {
      getEventColor(event) {
        return getEventColor(event)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sales/case/EventTypeSelect.vue